import React, { forwardRef } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../../utils/cn';
import { useFormField } from '../FormField/FormField';

const SIZES = {
  sm: 'h-8  text-sm   pl-2.5 pr-8',
  md: 'h-10 text-sm   pl-3   pr-9',
  lg: 'h-11 text-base pl-3.5 pr-10',
};

export const Select = forwardRef(function Select(
  { size = 'md', isInvalid, isDisabled, placeholder, options, children, className, id: idProp, ...rest },
  ref
) {
  const field = useFormField();
  const id = idProp || field?.id;
  const invalid = isInvalid || field?.invalid;

  return (
    <div className="relative inline-block w-full">
      <select
        ref={ref}
        id={id}
        disabled={isDisabled}
        aria-invalid={invalid || undefined}
        aria-describedby={field?.describedBy}
        className={cn(
          'w-full appearance-none bg-surface text-text outline-none',
          'border border-border rounded-md transition-colors duration-fast',
          'focus:bg-surface focus:border-ink focus:ring-2 focus:ring-ink/15',
          'disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-bg-2',
          SIZES[size],
          invalid && 'border-danger focus:border-danger focus:ring-danger/20',
          className,
        )}
        {...rest}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options
          ? options.map((opt) => (
              typeof opt === 'object'
                ? <option key={opt.value} value={opt.value} disabled={opt.disabled}>{opt.label}</option>
                : <option key={opt} value={opt}>{opt}</option>
            ))
          : children}
      </select>
      <ChevronDown className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-mute" strokeWidth={1.8} />
    </div>
  );
});

export default Select;
